module.exports = __webpack_public_path__ + "img/bizpal-logo.fd1194c7.png";